export const HOME_PATH = '/';

export const ISSUES_HOME = '/tickets';

export const DASHBOARD_HOME = '/UnifiedDashboardPage/null';

export const plantDashboard = (plantId: string): string => `/dashboardPage/${plantId}`;
